import { API_URL } from './api';

export type PublicMatch = Record<string, any>;
export type MatchOverrideMap = Record<string, PublicMatch>;

const resolveBackendUrl = (path: string): string => {
  try {
    if (/^https?:\/\//i.test(path)) return path;
    if (path.startsWith('/cache') || path.startsWith('/uploads') || path.startsWith('/api/')) {
      const origin = new URL(API_URL, typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000').origin;
      return new URL(path, origin).toString();
    }
    return path;
  } catch {
    return path;
  }
};

const fetchJSON = async <T>(path: string): Promise<T | null> => {
  try {
    const url = resolveBackendUrl(path);
    const res = await fetch(url, { cache: 'no-cache' });
    if (!res.ok) return null;
    return (await res.json()) as T;
  } catch {
    return null;
  }
};

export const loadMatchOverrideMap = async (): Promise<MatchOverrideMap> => {
  const [upcoming, past] = await Promise.all([
    fetchJSON<PublicMatch[]>('/api/v1/matches'),
    fetchJSON<PublicMatch[]>('/api/v1/matches/history'),
  ]);
  const map: MatchOverrideMap = {};
  const add = (arr: PublicMatch[] | null) => {
    if (!Array.isArray(arr)) return;
    for (const it of arr) {
      const id = String((it as any)?.match_id || (it as any)?.id || '').trim();
      if (!id) continue;
      if (!map[id]) {
        map[id] = it;
      } else {
        map[id] = { ...map[id], ...it };
      }
    }
  };
  add(upcoming);
  add(past);
  return map;
};
